module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAbCAYAAABm409WAAAAAXNSR0IArs4c6QAAAPBJREFUSA1jZCACaGs3sH3986b5PwNDLEg5IwPDYm4WkdqrVxt+EdLOQkgBSB5s+P//ZTC1QIvKgGIgbjlMDBfNhEsCWRzmckJiyPIwNlEWMPz/LwnTAKexicElEQziLECoJ5k1agHBIBsNotEgIhgCBBXQPBUxKmjkNPz/97+eoFPIUMDIxNjI/OHNqQOCouaMDP8ZHMgwA6cWkOEPbkxpYAapoLYlMMNBZoMtoKYlyIajWEANS9ANx7CAEkuwGY7VAnIswWU4TgtIsQSf4XgtIMYSQoYTtACfJcQYTpQF2Cwh1nCQXpIAqFgBYVI0AQAMDXelkKZ7lgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/order-arrow.png
// module id = 1459
// module chunks = 0